<template>
  <quote-wrapper
    :quote="quote"
    :details="qd"
    @toggle-quote-shown="$emit('toggle-quote-shown', $event)"
  >
    <!-- DESKTOP -->
    <template #desktop-quote>
      <quote-desktop
        :quote="quote"
        :details="qd"
        :options="quoteOptions"
        :is-view-monthly="isViewMonthly"
        @click-policy-details="onClickViewDetails(quote)"
      />
    </template>

    <!-- TABLETS/MOBILES -->
    <template #mobile-quote>
      <quote-mobile
        :quote="quote"
        :details="qd"
        :is-view-monthly="isViewMonthly"
        :covered-optional-extras="coveredOptionalExtras"
        @click-policy-details="onClickViewDetails(quote)"
      />
    </template>
  </quote-wrapper>
</template>

<script>
import QuoteWrapper from '@/components/results/QuoteWrapper';
import QuoteDesktop from './QuoteDesktop';
import QuoteMobile from './QuoteMobile';

export default {
  name: 'results-quote',
  inject: ['constants'],
  components: {
    QuoteWrapper,
    QuoteDesktop,
    QuoteMobile,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    detailsDescription: {
      type: Object,
      required: true,
    },
    optionalExtraValues: {
      type: Array,
      default: null,
    },
  },
  computed: {
    qd () {
      return this.quote.details[0];
    },
    quoteOptions () {
      return this.constants.DESKTOP_QUOTE_OPTIONS.map(option => {
        return {
          name: option,
          covered: this.convertOptionalExtrasValue(this.qd[option]),
        };
      });
    },
    filteredOptionalExtraValues () {
      return this.optionalExtraValues.filter(value => this.qd[value]);
    },
    coveredOptionalExtras () {
      return this.detailsDescription.content.reduce((acc, { name, slug }) => {
        if (this.filteredOptionalExtraValues.includes(slug)) {
          return [
            ...acc,
            {
              name,
              icon: this.constants.OPTIONAL_EXTRAS_STATES_ICONS[this.convertOptionalExtrasValue(this.qd[slug])],
            },
          ];
        }

        return acc;
      }, []);
    },
  },
  methods: {
    onClickViewDetails (quote) {
      this.$emit('click-view-details', quote);
      this.$emit('open-drawer-details', ['results-details', 'optionalExtras']);
    },
    convertOptionalExtrasValue (value) {
      return value === 'EXTRA' ? 'extra' : value ? 'Y' : 'N';
    },
  },
};
</script>
